module.exports = "/images/vendor/flag-icon-css/flags/1x1/mv.svg?0fdc08c6985e30f2a3bfd6b5069c6757";